import { render, staticRenderFns } from "./versions-list-filter.vue?vue&type=template&id=2d0b8f16&"
import script from "./versions-list-filter.vue?vue&type=script&lang=js&"
export * from "./versions-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports